import { fetcher } from '@commenda/utils';

export async function markPaymentIntentCollected(
  affiliateFirmId: string,
  paymentIntentId: string
) {
  return fetcher(
    `affiliate-firms/${affiliateFirmId}/payment-intents/${paymentIntentId}/mark-collected`,
    { method: 'PATCH' }
  );
}
